import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import {FinanceService} from '../finance.service';
declare var $:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers:[FinanceService]
})
export class DashboardComponent implements OnInit {

	role;
	successalert = false;
	successMessage : string;
	errorMessage : string;
	erroralert = false;
	projectList;

  constructor(
  	private loaderService : LoaderService,
  	private financeService:FinanceService
  ) { }

  ngOnInit() {
  	this.loaderService.display(false);
  	this.getProjectList();
  }

  getProjectList(){
  	this.loaderService.display(true);
  	this.financeService.getProjectList().subscribe(
  		res=>{
  			this.projectList=res.projects;
  			this.loaderService.display(false);
  		},
  		err=>{
  			console.log(err);
  			this.loaderService.display(false);
  		}
  	);
  }

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/finance/dashboard/dashboard.component.ts